export * from "./levels.js";
export * from "./logger-factory.js";
export * from "./logger.js";

export const isSipLoggingDisable = () => {
  if (typeof localStorage === "undefined") {
    return false;
  }
  return !!localStorage.getItem("disableSipLogging");
};
